var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1692_2180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.8125 8.3125H10.6875V1.1875C10.6875 0.531666 10.1558 0 9.5 0C8.84417 0 8.3125 0.531666 8.3125 1.1875V8.3125H1.1875C0.531666 8.3125 0 8.84417 0 9.5C0 10.1558 0.531666 10.6875 1.1875 10.6875H8.3125V17.8125C8.3125 18.4683 8.84417 19 9.5 19C10.1558 19 10.6875 18.4683 10.6875 17.8125V10.6875H17.8125C18.4683 10.6875 19 10.1558 19 9.5C19 8.84417 18.4683 8.3125 17.8125 8.3125Z",
    fill: "#797979"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1692_2180"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusUpload);
export default __webpack_public_path__ + "static/media/plus-upload.bc3d4e9b540cb8c025838b82cf7de1b0.svg";
export { ForwardRef as ReactComponent };